module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": '500px',
      "min-width": "420px"
    },
    on: {
      "close": _vm.localCloseModal
    }
  }, [(_vm.keycard.pool_lid) ? _c('div', [_c('div', {
    staticClass: "padding"
  }, [_c('h1', [_vm._v("Oladdade liftkort")]), _vm._v(" "), _c('div', {
    staticClass: "blocked center"
  }, [_c('b', {
    staticClass: "uppercase block"
  }, [_vm._v("Antal liftkort")]), _vm._v(" "), _c('CounterButton', {
    ref: "counterButton",
    staticClass: "counter-button",
    attrs: {
      "inline": true,
      "count": _vm.peopleCount,
      "min": 1,
      "suffix": ' ' + _vm.$t('general.pieces-short')
    },
    on: {
      "changedCount": function($event) {
        return _vm.changePeople($event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "blocked info blue"
  }, [_vm._v("\n      Liftkortet kostar " + _vm._s(_vm._f("currency")(_vm.keycard.price)) + " och skickas hem till dig. Leveransen tar ca en vecka.\n      "), (_vm.SITE_CONFIG.site === 'branas') ? _c('span', [_vm._v("Du vet väl att du kan lägga till liftkort till din skidhyra eller till din boendebokning och få leverans tillsammans med nycklar eller skidutrustning.")]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site === 'kungsberget') ? _c('span', [_vm._v("Du vet väl att du även kan lägga till liftkort till din skidhyra eller till din boendebokning.")]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site === 'vallasen' || _vm.SITE_CONFIG.site === 'ulricehamn') ? _c('span', [_vm._v("Du vet väl att du kan lägga till liftkort till din skidhyra och få dem levererade tillsammans med skidutrustningen.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "padding"
  }, [_c('div', {
    staticClass: "blocked center"
  }, [_c('button', {
    attrs: {
      "disabled": !_vm.validate()
    },
    on: {
      "click": function($event) {
        return _vm.startBooking()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.cta.book')) + " "), _c('icon', {
    attrs: {
      "name": "arrow-white",
      "scale": 1.4
    }
  })], 1)])])]) : _c('div', {
    staticClass: "padding"
  }, [_c('h1', [_vm._v("Oladdade liftkort")]), _vm._v(" "), _c('div', {
    staticClass: "blocked info-box center"
  }, [_vm._v("\n      Oops, det finns inget oladdat liftkort att köpa här för tillfället. Kontakta gärna gästservice om du har några frågor: "), _c('a', {
    attrs: {
      "href": "tel:054-13 26 00"
    }
  }, [_vm._v("054-13 26 00")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-103faf18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/SkiPassPickDateKeycard.vue
// module id = 917
// module chunks = 0